import {
  SET_MINI_CONFIG,
  SET_MINI_LOCK,
  SET_MINI_LOCK_FILE,
  SET_MINI_SIDEBAR_OPEN,
  RUN_MINI_FILE_ACTION,
  CLEAR_MINI_FILE_ACTION,
  SHOW_MODAL_MINI,
  HIDE_MODAL_MINI,
  SHOW_MODAL_TOP_MINI,
  HIDE_MODAL_TOP_MINI,
  SHOW_MODAL_TOP_SECOND_MINI,
  HIDE_MODAL_TOP_SECOND_MINI,
  SET_UPLOAD_PROGRESS,
  SHOW_MINI_CONFIRMATION_MODAL,
  HIDE_MINI_CONFIRMATION_MODAL,
  SET_MINI_OPENED_FILES,
  SET_MINI_ACTIVE_FILE,
  SET_MINI_OVERLAY,
} from '../actions/Mini';

const initialConfirmationModalParams = {
  title: null,
  text: '',
  confirmText: null,
  cancelText: null,
  onConfirm: () => (Promise.resolve()),
  onCancel: () => (Promise.resolve()),
};

const initialState = {
  config: null,
  lock: false,
  lockFileUuid: null,
  sidebarOpen: false,
  fileAction: {
    file: null,
    files: [],
    action: null,
  },
  modal: null,
  modalProps: {},
  modalTop: null,
  modalTopProps: {},
  modalTopSecond: null,
  modalTopSecondProps: {},
  uploadProgress: 0,
  confirmationModal: false,
  confirmationModalParams: initialConfirmationModalParams,
  openedFiles: [],
  activeFile: null,
  overlay: {
    show: false,
    header: '',
    subheader: '',
    loading: false,
    progress: null,
  },
};

export const Mini = (state = initialState, action) => {
  switch (action.type) {
    case SET_MINI_CONFIG:
      return Object.assign({}, state, {
        config: {
          ...window.sp.miniConfig,
          ...state.config,
          ...action.config,
          eventTarget: undefined,
        },
      });

    case SET_MINI_LOCK:
      return Object.assign({}, state, {
        lock: action.lock,
      });

    case SET_MINI_LOCK_FILE:
      return Object.assign({}, state, {
        lockFileUuid: action.fileUuid,
      });

    case SET_MINI_SIDEBAR_OPEN:
      return Object.assign({}, state, {
        sidebarOpen: action.open,
      });

    case RUN_MINI_FILE_ACTION: {
      let fileAction = action.action;
      if (!fileAction && action.event) {
        fileAction = state.config.actions.find(a => (a.events && a.events.includes(action.event)));
      }

      return Object.assign({}, state, {
        fileAction: {
          file: action.file,
          files: action.files,
          action: fileAction,
        },
      });
    }

    case CLEAR_MINI_FILE_ACTION:
      return Object.assign({}, state, {
        fileAction: {
          file: null,
          action: null,
        },
      });

    case SHOW_MODAL_MINI:
      return Object.assign({}, state, {
        modal: action.modal,
        modalProps: action.modalProps,
      });

    case HIDE_MODAL_MINI:
      return Object.assign({}, state, {
        modal: null,
        modalProps: {},
      });

    case SHOW_MODAL_TOP_MINI:
      return Object.assign({}, state, {
        modalTop: action.modal,
        modalTopProps: action.modalProps,
      });

    case HIDE_MODAL_TOP_MINI:
      return Object.assign({}, state, {
        modalTop: null,
        modalTopProps: {},
      });

    case SHOW_MODAL_TOP_SECOND_MINI:
      return Object.assign({}, state, {
        modalTopSecond: action.modal,
        modalTopSecondProps: action.modalProps,
      });

    case HIDE_MODAL_TOP_SECOND_MINI:
      return Object.assign({}, state, {
        modalTopSecond: null,
        modalTopSecondProps: {},
      });

    case SET_UPLOAD_PROGRESS:
      return Object.assign({}, state, {
        uploadProgress: action.uploadProgress,
      });

    case SHOW_MINI_CONFIRMATION_MODAL:
      return Object.assign({}, state, {
        confirmationModal: true,
        confirmationModalParams: Object.assign({}, initialConfirmationModalParams, action.params),
      });

    case HIDE_MINI_CONFIRMATION_MODAL:
      return Object.assign({}, state, {
        confirmationModal: false,
      });

    case SET_MINI_OPENED_FILES:
      return Object.assign({}, state, {
        openedFiles: action.openedFiles,
      });

    case SET_MINI_ACTIVE_FILE:
      return Object.assign({}, state, {
        activeFile: action.activeFile,
      });

    case SET_MINI_OVERLAY:
      return Object.assign({}, state, {
        overlay: action.overlay,
      });

    default:
      return state;
  }
};
